import React from "react"

import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"


export default function OfficesColumn() {
	return {
		name: "officesName", label: "Offices",
		options: {
			sort: false,
			customBodyRowRenderLite: value => <AppOfficesBlockContainer rows={value} />
		}
	}
}